import * as core from '../../../../../../../core'
import * as cursorTracker from '../cursor-tracker'

export const RESOURCE = {
  payload: {
    alias: 'dashboard',
    appAlias: cursorTracker.RESOURCE.payload.alias,
    description: 'Overview of Cursor usage, hours saved, cost, and ROI.',
    display: {
      isMain: true,
      position: 1,
    },
    name: 'Dashboard',
    page: { alias: 'dashboard' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
